import OutUser from './OutUser';

export default OutUser;
